import { j as o } from "../../../../jsx-runtime-p91LotPX.mjs";
import { ColumnIcon as r } from "../../../../Icons/Icons.js";
import "../../../../GrowAvatar-DJSlhesM.mjs";
import { GrowButton as i } from "../../../Button/AntButton.js";
import "../../../CheckBox/style.js";
import "../../../Typography/AntTypography.js";
import "../../../utils/datetime-formatter.js";
import "../../../../core.esm-D9FG3ApV.mjs";
import "../../../../SortableItem-C--6XTJo.mjs";
import "../../../../lodash-lyheMOjd.mjs";
import "react";
import "../../../Dnd/SortableContainer.js";
import "../../../../style-ClHoikNh.mjs";
import "../../../../AntDrawer-ChgesM8B.mjs";
import "../../../../style-BCs5tvAM.mjs";
import "../../../StatusTag/style.js";
import "../../../../main-C3-4ZYQP.mjs";
import "./ColumnSortList.js";
import "../../../../table-XsUAem3c.mjs";
import "../../../../style-pk1ekFUy.mjs";
import "../../BulkAction/style.js";
import "../../Pagination/style.js";
import "../../style.js";
import "../../../Tree/style.js";
import "../../../UI/FormArea/FormFooter.js";
import "../../../css.js";
import { T as m } from "../../../../index-BP092b3A.mjs";
function R(t) {
  return /* @__PURE__ */ o.jsx(m, { title: "Organize Columns", placement: "left", trigger: ["hover"], children: /* @__PURE__ */ o.jsx(i, { icon: /* @__PURE__ */ o.jsx(r, { color: "var(--primary-7)" }), onClick: () => {
    t.api.dispatchEvent({
      type: "columnCustomOpen"
    });
  } }) });
}
export {
  R as ColumnSortButton
};
//# sourceMappingURL=ColumnSortButton.js.map
